import callApi from "../../api/axios";

export const getPartnerTrackingLinks = (id) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/tracking-links`,
  });
};

export const getPartnerTrackingStats = ({ id, st, et }) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/tracking-stats?st=${st}&et=${et}`,
  });
};

export const getPartnerCommission = ({ id, st, et, limit, offset }) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/commissions?st=${st}&et=${et}&limit=${limit}&offset=${offset}`,
  });
};

export const getPartnerPayment = ({ id, st, et, limit, offset }) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/payments?st=${st}&et=${et}&limit=${limit}&offset=${offset}`,
  });
};

export const getPartnerSummary = (id) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/summaries`,
  });
};

export const createPartnerPayment = (values) => {
  return callApi({
    method: "POST",
    url: `payments`,
    data: values,
  });
};

export const updatePartnerPayment = (values) => {
  return callApi({
    method: "PUT",
    url: `payments/${values._id}`,
    data: values,
  });
};

export const removePartnerCommission = (id) => {
  return callApi({
    method: "DELETE",
    url: `commissions/${id}`,
  });
};

export const removePartnerPayment = (id) => {
  return callApi({
    method: "DELETE",
    url: `payments/${id}`,
  });
};

export const getCoupon = (id) => {
  return callApi({
    method: "GET",
    url: `partners/${id}/coupon-codes`,
  });
};

export const createCoupon = (values) => {
  return callApi({
    method: "POST",
    url: `coupon-codes`,
    data: values,
  });
};

export const updateCoupon = (values) => {
  return callApi({
    method: "PUT",
    url: `coupon-codes/${values._id}`,
    data: values,
  });
};

export const removeCoupon = (id) => {
  return callApi({
    method: "DELETE",
    url: `coupon-codes/${id}`,
  });
};

export const createShortLink = ({ trackingLinkId, partnerId, alias }) => {
  return callApi({
    method: "POST",
    url: `partners/${partnerId}/short-link/${trackingLinkId}`,
    data: { alias },
  });
};

export const getW9Form = (partnerId) => {
  return callApi({
    method: "GET",
    url: `partners/${partnerId}/w9-form`,
  });
};

export const updateW9Form = (values) => {
  return callApi({
    method: "POST",
    url: `partners/${values.partnerId}/w9-form`,
    data: values,
  });
};
